import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TenantsList from './components/TenantsList';
import AddTenant from './components/AddTenant';
import UserProfile from './components/UserProfile';
import TenantDetails from './components/TenantDetails';

const App = () => {
  return (
    <Router>
      <div>
      <UserProfile />

        <Routes>
          <Route path="/" element={<TenantsList />} />
          <Route path="/tenant/:tenantId" element={<TenantDetails />} /> {/* Route for tenant details */}
          <Route path="/add-tenant" element={<AddTenant />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
